module.exports = __webpack_public_path__ + "static/img/icon_info.246c8f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/saleActive/icon_info.svg
// module id = SyDW
// module chunks = 1